// Shared by the Mapping and Review screens so the same PDF renders at the same zoom on both.
// Kept in one place deliberately: when these were duplicated, tuning one screen silently left
// the other behaving differently for the same file.
const PDF_CARD_PADDING = 20;
const MIN_RENDER_SCALE = 0.6;
const MAX_RENDER_SCALE = 2;

// Fits the page to its card's width, clamped so a tiny page isn't blown up past legibility
// and a large one isn't shrunk past it either.
export const fitScaleFor = (naturalWidth, containerEl) => {
  const availableWidth = containerEl
    ? containerEl.clientWidth - PDF_CARD_PADDING * 2
    : naturalWidth;
  return Math.min(MAX_RENDER_SCALE, Math.max(MIN_RENDER_SCALE, availableWidth / naturalWidth));
};

export default fitScaleFor;
